// extracted by mini-css-extract-plugin
export default {"list":"style_list__sfZkK","row":"style_row__IGd0m","icon":"style_icon__R597n"};